/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateVehicleRequest
 */
export interface UpdateVehicleRequest {
    /**
     * 営業所ID
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    salesOfficeId: string;
    /**
     * ナンバープレート上部
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    plateNoUpper: string;
    /**
     * ナンバープレート下部
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    plateNoBottom: string;
    /**
     * ドア番号
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    doorNo: string;
    /**
     * 車種コード
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    carTypeCode: string;
    /**
     * 車体色のRGBコード
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    colorRgb: string;
    /**
     * 初度登録年月（YYYY/MM）
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    firstRegistrationDate: string;
    /**
     * メーターモード (0:迎車連携有り, 1:迎車連携無し, 2:メータ無し)
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    meterMode: UpdateVehicleRequestMeterModeEnum;
    /**
     * 配車可能フラグ
     * @type {boolean}
     * @memberof UpdateVehicleRequest
     */
    available: boolean;
    /**
     * 個人タクシー事業者名（個人タクシーのみ）
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    ownerDrivenTaxiName?: string;
    /**
     * インボイス番号（個人タクシーのみ）
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    invoiceNo?: string;
    /**
     * 備考（任意）
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    description: string;
}


/**
 * @export
 */
export const UpdateVehicleRequestMeterModeEnum = {
    _0: '0',
    _1: '1',
    _2: '2'
} as const;
export type UpdateVehicleRequestMeterModeEnum = typeof UpdateVehicleRequestMeterModeEnum[keyof typeof UpdateVehicleRequestMeterModeEnum];


/**
 * Check if a given object implements the UpdateVehicleRequest interface.
 */
export function instanceOfUpdateVehicleRequest(value: object): value is UpdateVehicleRequest {
    if (!('salesOfficeId' in value) || value['salesOfficeId'] === undefined) return false;
    if (!('plateNoUpper' in value) || value['plateNoUpper'] === undefined) return false;
    if (!('plateNoBottom' in value) || value['plateNoBottom'] === undefined) return false;
    if (!('doorNo' in value) || value['doorNo'] === undefined) return false;
    if (!('carTypeCode' in value) || value['carTypeCode'] === undefined) return false;
    if (!('colorRgb' in value) || value['colorRgb'] === undefined) return false;
    if (!('firstRegistrationDate' in value) || value['firstRegistrationDate'] === undefined) return false;
    if (!('meterMode' in value) || value['meterMode'] === undefined) return false;
    if (!('available' in value) || value['available'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function UpdateVehicleRequestFromJSON(json: any): UpdateVehicleRequest {
    return UpdateVehicleRequestFromJSONTyped(json, false);
}

export function UpdateVehicleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateVehicleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'salesOfficeId': json['sales_office_id'],
        'plateNoUpper': json['plate_no_upper'],
        'plateNoBottom': json['plate_no_bottom'],
        'doorNo': json['door_no'],
        'carTypeCode': json['car_type_code'],
        'colorRgb': json['color_rgb'],
        'firstRegistrationDate': json['first_registration_date'],
        'meterMode': json['meter_mode'],
        'available': json['available'],
        'ownerDrivenTaxiName': json['owner_driven_taxi_name'] == null ? undefined : json['owner_driven_taxi_name'],
        'invoiceNo': json['invoice_no'] == null ? undefined : json['invoice_no'],
        'description': json['description'],
    };
}

export function UpdateVehicleRequestToJSON(json: any): UpdateVehicleRequest {
    return UpdateVehicleRequestToJSONTyped(json, false);
}

export function UpdateVehicleRequestToJSONTyped(value?: UpdateVehicleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sales_office_id': value['salesOfficeId'],
        'plate_no_upper': value['plateNoUpper'],
        'plate_no_bottom': value['plateNoBottom'],
        'door_no': value['doorNo'],
        'car_type_code': value['carTypeCode'],
        'color_rgb': value['colorRgb'],
        'first_registration_date': value['firstRegistrationDate'],
        'meter_mode': value['meterMode'],
        'available': value['available'],
        'owner_driven_taxi_name': value['ownerDrivenTaxiName'],
        'invoice_no': value['invoiceNo'],
        'description': value['description'],
    };
}

